import { Injectable } from '@angular/core'
import { EventApi } from './base'

@Injectable()
export class VideoEventApi extends EventApi{
  apiPath(resourceId: number, areaId = '') {
    return `videos/${resourceId}/events/${areaId}`
  }
}



// WEBPACK FOOTER //
// ./src/apis/event/video.ts